import {UserSession} from "../../contract-features-3/domain";

export default class GroupAdminState {
    constructor(
        readonly contractGroups: ContractGroup[] = [],
        readonly selectedContractGroupId: string = null,
        readonly user: UserSession = null,
        readonly highlightedUserName: string = null,
        readonly isLoading = true,
    ) { }

    private create(overrides: Partial<GroupAdminState>) {
        const params = Object.assign({}, this, overrides);
        const state = new GroupAdminState(
            params.contractGroups,
            params.selectedContractGroupId,
            params.user,
            params.highlightedUserName,
            params.isLoading,
        );
        console.log(state);
        return state;
    }

    public withHighlightedUser(highlightedUserName: string) {
        return this.create({highlightedUserName})
    }

    public withUser(user: UserSession){
        return this.create({user});
    }

    public withContractGroups(contractGroups: ContractGroup[]) {
        return this.create({contractGroups});
    }

    public withSelectedContractGroup(selectedContractGroupId: string) {
        return this.create({selectedContractGroupId})
    }

    public withIsLoading(isLoading: boolean){
        return this.create({isLoading})
    }

}

export type ContractGroup = {
    id: string,
    name: string,
    contracts: Contract[],
    users: GroupUser[]
}

export type Contract = {
    id: string,
    name: string,
}

export type GroupUser = {
    displayname: string,
    username: string,
    role: string
}